import { useGetMaxRolesQuery } from '#api/roles.queries.ts';

export const ALL_ROLES_FLAG = 'all';

const ALL_HOSTS_OPTION: { value: string; label: string } = { value: ALL_ROLES_FLAG, label: 'All hosts' };

export function useGetRolesForSelection() {
  const query = useGetMaxRolesQuery();

  return {
    ...query,
    data:
      query.data?.data ?
        { items: [ALL_HOSTS_OPTION].concat(query.data.data.map((role) => ({ value: role.id, label: role.name }))) }
      : { items: [] },
  };
}
